export const GET_PETITION_UUID_REQUEST = 'GET_PETITION_UUID_REQUEST';
export const GET_PETITION_UUID_SUCCESS = 'GET_PETITION_UUID_SUCCESS';
export const GET_PETITION_UUID_FAILURE = 'GET_PETITION_UUID_FAILURE';

export const GET_PETITION_IMAGES_REQUEST = 'GET_PETITION_IMAGES_REQUEST';
export const GET_PETITION_IMAGES_SUCCESS = 'GET_PETITION_IMAGES_SUCCESS';
export const GET_PETITION_IMAGES_FAILURE = 'GET_PETITION_IMAGES_FAILURE';

export const RESET_VIEWER = 'RESET_VIEWER';
